import { useSelector } from "react-redux";
import { handleDetailResponse, handleListResponse } from "./utils";

const usePermission = ({
  create: createStr,
  view: viewStr,
  edit: editStr,
  update: updateStr,
  remove: removeStr,
  bulk: bulkStr,
  status:statusStr
}) => {
  const permissionSelector = useSelector((state) => state.permission);
  const { response, isAdmin = false } = permissionSelector;
  let create = isAdmin
    ? true
    : createStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === createStr)
    )?.permission;

  let edit = isAdmin
    ? true
    : editStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === editStr)
    )?.permission;
  let update = isAdmin
    ? true
    : updateStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === updateStr)
    )?.permission;
  let bulk = isAdmin
    ? false
    : bulkStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === bulkStr)
    )?.permission;
  let view = isAdmin
    ? true
    : viewStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === viewStr)
    )?.permission;
  let remove = isAdmin
    ? true
    : removeStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === removeStr)
    )?.permission;

  let status = isAdmin
    ? true
    : statusStr &&
    handleDetailResponse(
      handleListResponse(response).filter((i) => i.slug === statusStr)
    )?.permission;
  return { create, edit, view, remove, isAdmin, update, bulk ,status};
};
// const usePermission = ({
//   create: createStr,
//   view: viewStr,
//   edit: editStr,
//   update: updateStr,
//   remove: removeStr,
//   bulk: bulkStr,
// }) => {
//   const permissionSelector = useSelector((state) => state.permission);
//   const { response, isAdmin = false } = permissionSelector;
//   let create = isAdmin
//     ? true
//     : createStr &&
//     handleDetailResponse(
//       handleListResponse(response).filter((i) => i.slug === createStr)
//     )?.permission;

//   let edit = isAdmin
//     ? true
//     : editStr &&
//     handleDetailResponse(
//       handleListResponse(response).filter((i) => i.slug === editStr)
//     )?.permission;
//   let update = isAdmin
//     ? true
//     : updateStr &&
//     handleDetailResponse(
//       handleListResponse(response).filter((i) => i.slug === updateStr)
//     )?.permission;
//   let bulk = isAdmin
//     ? false
//     : bulkStr &&
//     handleDetailResponse(
//       handleListResponse(response).filter((i) => i.slug === bulkStr)
//     )?.permission;
//   let view = isAdmin
//     ? true
//     : viewStr &&
//     handleDetailResponse(
//       handleListResponse(response).filter((i) => i.slug === viewStr)
//     )?.permission;
//   let remove = isAdmin
//     ? true
//     : removeStr &&
//     handleDetailResponse(
//       handleListResponse(response).filter((i) => i.slug === removeStr)
//     )?.permission;
//   return { create, edit, view, remove, isAdmin, update, bulk };
// };
export default usePermission;
